export default __webpack_public_path__ + "static/media/makerlabCoin.6e7d146e.svg";